// Vendors
import React from 'react';
// Components
import { PaymentElement } from '@stripe/react-stripe-js';
// Constants
import { PAYMENT_ELEMENT_PROPS } from './constants/payment-landing-form.constants';
// Hooks
import { usePaymentLandingFormHook } from './hooks/payment-landing-form.hook';

const PaymentLandingFormComponent = (): React.JSX.Element => {
  const { handlePaymentFormComplete } = usePaymentLandingFormHook();

  return <PaymentElement {...PAYMENT_ELEMENT_PROPS} onChange={handlePaymentFormComplete} />;
};

export { PaymentLandingFormComponent };
